import { Box, ButtonAsync, ButtonSpinner, ButtonText, FormControl, FormControlError, FormControlErrorText, FormControlLabel, FormControlLabelText, Heading, Input, InputField, Text, VStack, } from '../../primitives';
import React, { useContext, useState } from 'react';
import { useRoutingLib, useUser } from '../../../hooks';
import { DB, isValidPassword } from '@tonic/central-specialties-utils';
import { UserContext } from '../../providers';
const newPasswordFormErrorMessages = {
    empty: 'Empty field',
    // incorrect: 'Password is incorrect',
    dontMatch: 'Passwords do not match',
    invalid: 'Password must be at least 6 characters, contain at least one capital letter, lowercase letter, number and symbol.',
    none: '',
};
export const ChangePasswordPrompt = ({ onSuccess, initial = false, }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [formErrors, setFormErrors] = useState({
        newPassword: null,
        confirmNewPassword: null,
    });
    const [serverError, setServerError] = useState(null);
    const [pending, setPending] = useState(false);
    const user = useUser();
    const { sync } = useContext(UserContext);
    const { useNavigate } = useRoutingLib();
    const navigate = useNavigate();
    const getFieldSetter = (field) => {
        switch (field) {
            case 'currentPassword':
                return setCurrentPassword;
            case 'newPassword':
                return setNewPassword;
            case 'confirmNewPassword':
                return setConfirmNewPassword;
            default:
                throw new Error("can't getFieldSetter for invalid field: " + field);
        }
    };
    const onChange = (field) => (val) => {
        const setValueState = getFieldSetter(field);
        setValueState(val);
        setFormErrors({ newPassword: null, confirmNewPassword: null });
        setServerError(null);
    };
    const onPressConfirm = async () => {
        if (!user) {
            console.error('No user present on change password attempt!');
            return;
        }
        if (!currentPassword) {
            alert('Please enter current password');
            return;
        }
        if (!isValidPassword(newPassword)) {
            setFormErrors({
                newPassword: 'invalid',
                confirmNewPassword: null,
            });
        }
        else if (newPassword !== confirmNewPassword) {
            setFormErrors({
                newPassword: 'dontMatch',
                confirmNewPassword: 'dontMatch',
            });
        }
        else {
            setPending(true);
            try {
                await DB.auth.changePassword(currentPassword, newPassword);
                if (onSuccess) {
                    onSuccess();
                }
                else {
                    navigate('/auth/login');
                }
            }
            catch (e) {
                // TODO: Handle other potential server errors
                setServerError('Incorrect password');
                // console.log("ERRROR", e);
            }
            await sync();
            setPending(false);
        }
    };
    return (React.createElement(Box, { sx: {
            _web: { w: '$92' },
            _ios: { w: '$full' },
            _android: { w: '$full' },
        }, alignSelf: "center" },
        React.createElement(VStack, { alignItems: "center", space: "xl" },
            initial && (React.createElement(React.Fragment, null,
                React.createElement(Heading, { size: "xl" }, "Welcome!"),
                React.createElement(VStack, { alignItems: "center", mx: "$2" },
                    React.createElement(Text, { size: "lg" }, "Please create your password"),
                    React.createElement(Text, { size: "md", textAlign: "center" }, "Password must be at least 6 characters, contain at least one capital letter, lowercase letter, number and symbol.")))),
            React.createElement(FormControl, { size: "lg", width: "$full", isInvalid: serverError !== null, mb: "$4" },
                React.createElement(FormControlLabel, null,
                    React.createElement(FormControlLabelText, null, "Current password")),
                React.createElement(Input, { size: "lg", isDisabled: pending },
                    React.createElement(InputField, { value: currentPassword, onChangeText: onChange('currentPassword'), autoComplete: "current-password", autoCapitalize: "none", type: "password", placeholder: "********" })),
                React.createElement(FormControlError, null,
                    React.createElement(FormControlErrorText, null, serverError))),
            React.createElement(FormControl, { size: "lg", width: "$full", isInvalid: formErrors.newPassword !== null },
                React.createElement(FormControlLabel, null,
                    React.createElement(FormControlLabelText, null, "New password")),
                React.createElement(Input, { size: "lg", isDisabled: pending },
                    React.createElement(InputField, { value: newPassword, onChangeText: onChange('newPassword'), autoComplete: "new-password", autoCapitalize: "none", type: "password", placeholder: "********" })),
                React.createElement(FormControlError, null,
                    React.createElement(FormControlErrorText, null, newPasswordFormErrorMessages[formErrors.newPassword || 'none']))),
            React.createElement(FormControl, { size: "lg", width: "$full", isInvalid: formErrors.confirmNewPassword !== null },
                React.createElement(FormControlLabel, null,
                    React.createElement(FormControlLabelText, null, "Confirm Password")),
                React.createElement(Input, { size: "lg", isDisabled: pending },
                    React.createElement(InputField, { value: confirmNewPassword, onChangeText: onChange('confirmNewPassword'), autoComplete: "new-password", autoCapitalize: "none", type: "password", placeholder: "********" })),
                React.createElement(FormControlError, null,
                    React.createElement(FormControlErrorText, null, newPasswordFormErrorMessages[formErrors.confirmNewPassword || 'none']))),
            React.createElement(VStack, null,
                React.createElement(Text, null, " ")),
            React.createElement(ButtonAsync, { pending: pending, onPress: onPressConfirm, w: "$40", size: "lg" }, pending ? React.createElement(ButtonSpinner, null) : React.createElement(ButtonText, null, "Confirm")))));
};
